// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2et4B","name":"styles_name__j4_Wk","phone":"styles_phone__1OGLe"};